import { render, staticRenderFns } from "./kpytkb.vue?vue&type=template&id=11585a68&scoped=true"
import script from "./kpytkb.vue?vue&type=script&lang=js"
export * from "./kpytkb.vue?vue&type=script&lang=js"
import style0 from "./kpytkb.vue?vue&type=style&index=0&id=11585a68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11585a68",
  null
  
)

export default component.exports